const component = "select-site";

export const selectSite = {
  component,
  allSitesButton: `${component}/select-site-button/all-sites`,
  searchInput: `${component}/select-site-button/search-input`,
  siteOption: `${component}/select-site-button/site-option`,
};
